module.exports = __webpack_public_path__ + "static/media/paypal.f02b8147.svg";